import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload } from '@fortawesome/pro-solid-svg-icons'
import styles from './FileTemplate.module.scss'

export interface TemplateProps {
  link: string
  label: React.ReactNode
}

export const FileTemplate: React.FC<TemplateProps> = ({ label, link }) => (
  <a className={styles.bodyFont} target="_blank" rel="noreferrer" href={link}>
    <span>{label}</span>
    <FontAwesomeIcon
      icon={faFileDownload}
      className="mt-2 ml-2"
    ></FontAwesomeIcon>
  </a>
)
